import React from "react";

const NavigationDots = ({ sections, active }) => {
  return (
    <div className="app__navigation navigation-dots">
      {sections.map((section, id) => (
        <a
          href={`#${section}`}
          key={`section-${section}-${id}`}
          style={{ background: section === active && "#3399e1" }}
          className="app__navigation-dot navigate-dot"
        />
      ))}
    </div>
  );
};

export default NavigationDots;
